<template>
  <div class="flex items-center gap-2 p-2 px-4 w-full max-w-lg">
    <img
      v-if="userDetails?.avatar_image"
      :src="userDetails.avatar_image"
      alt="Profile Picture"
      class="w-11 h-11 rounded-full object-cover"
    />
    <div v-else class="w-11 h-11 rounded-full bg-gray-200 flex items-center justify-center">
      <User class="w-6 h-6 rounded-full text-gray-500" />
    </div>
    <div>
      <p class="text-lg">
        {{ userDetails?.first_name }}
        {{ userDetails?.last_name }}
        <span v-if="title">{{ title }}</span>
      </p>
      <p class="text-sm text-gray-500">
        {{ userDetails?.email }}
      </p>
    </div>

    <!-- Links -->
    <div class="flex items-center gap-2 ml-auto">
      <a v-if="userDetails?.linkedin_url" :href="userDetails.linkedin_url" target="_blank">
        <img src="/linkedin_logo.svg" alt="LinkedIn" class="w-4 h-4" />
      </a>
      <a v-if="userDetails?.telegram_url" :href="userDetails.telegram_url" target="_blank">
        <img src="/telegram_logo.svg" alt="GitHub" class="w-4 h-4" />
      </a>
      <a v-if="userDetails?.leetcode_url" :href="userDetails.leetcode_url" target="_blank">
        <img src="/leetcode_logo.svg" alt="LeetCode" class="w-4 h-4" />
      </a>
      <div class="flex items-end flex-col gap-1">
        <a
          v-if="userDetails?.username"
          :href="`https://outtalent.com/profile/${userDetails.username}`"
          target="_blank"
          class="text-xs text-gray-500 bg-white flex items-center gap-1 border border-gray-200 rounded-md px-2 py-1 hover:bg-gray-50"
        >
          <User class="w-4 h-4" />
          Community Profile
        </a>
        <a
          v-if="isGuide && userDetails?.username"
          :href="`https://campus.outtalent.com/manage/fellow/${userDetails.id}`"
          target="_blank"
          class="text-xs text-gray-500 bg-white flex items-center gap-1 border border-gray-200 rounded-md px-2 py-1 hover:bg-gray-50"
        >
          <User class="w-4 h-4" />
          Management Profile
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { User } from 'lucide-vue-next'
import { useAuth } from '@/composables/useAuth'

const { isGuide } = useAuth()

interface UserDetails {
  id?: number | null
  first_name?: string | null
  last_name?: string | null
  email?: string | null
  avatar_image?: string | null
  linkedin_url?: string | null
  telegram_url?: string | null
  leetcode_url?: string | null
  username?: string | null
}

defineProps<{
  userDetails?: UserDetails
  title?: string
}>()
</script>
